import { c as _c } from "react/compiler-runtime";
export function GooglePayIcon(t0) {
  const $ = _c(15);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    bgColor: t2,
    decorative
  } = t1;
  const bgColor = t2 === undefined ? "#FFF" : t2;
  const t3 = decorative ? undefined : "img";
  const t4 = decorative ? undefined : "Google Pay";
  const t5 = decorative || undefined;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z" fill="#000" opacity=".07" />;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== bgColor) {
    t7 = <path d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32" fill={bgColor} />;
    $[3] = bgColor;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t10;
  let t11;
  let t12;
  let t8;
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <path d="M18.093 11.976v3.2h-1.018v-7.9h2.691a2.447 2.447 0 0 1 1.747.692 2.28 2.28 0 0 1 .11 3.224l-.11.116c-.47.447-1.098.69-1.747.674l-1.673-.006zm0-3.732v2.788h1.698c.377.012.741-.135 1.005-.404a1.391 1.391 0 0 0-1.005-2.354l-1.698-.03zm6.484 1.348c.65-.03 1.286.188 1.778.613.445.43.682 1.03.65 1.649v3.334h-.969v-.766h-.049a1.93 1.93 0 0 1-1.673.931 2.17 2.17 0 0 1-1.496-.533 1.667 1.667 0 0 1-.613-1.324 1.606 1.606 0 0 1 .613-1.336 2.746 2.746 0 0 1 1.698-.515c.517-.02 1.03.093 1.49.331v-.208a1.134 1.134 0 0 0-.417-.901 1.416 1.416 0 0 0-.98-.368 1.545 1.545 0 0 0-1.319.717l-.895-.564a2.488 2.488 0 0 1 2.182-1.06zM23.29 13.52a.79.79 0 0 0 .337.662c.223.176.5.269.785.263.429-.001.84-.17 1.146-.472.305-.286.478-.685.478-1.103a2.047 2.047 0 0 0-1.324-.374 1.716 1.716 0 0 0-1.03.294.883.883 0 0 0-.392.73zm9.286-3.75l-3.39 7.79h-1.048l1.281-2.728-2.224-5.062h1.103l1.612 3.885 1.569-3.885h1.097z" fill="#5F6368" />;
    t9 = <path d="M13.986 11.284c0-.308-.024-.616-.073-.92h-4.29v1.747h2.451a2.096 2.096 0 0 1-.9 1.373v1.134h1.464a4.433 4.433 0 0 0 1.348-3.334z" fill="#4285F4" />;
    t10 = <path d="M9.629 15.721a4.352 4.352 0 0 0 3.01-1.097l-1.466-1.14a2.752 2.752 0 0 1-4.094-1.44H5.577v1.17a4.53 4.53 0 0 0 4.052 2.507z" fill="#34A853" />;
    t11 = <path d="M7.079 12.05a2.709 2.709 0 0 1 0-1.735v-1.17H5.577a4.505 4.505 0 0 0 0 4.075l1.502-1.17z" fill="#FBBC04" />;
    t12 = <path d="M9.629 8.44a2.452 2.452 0 0 1 1.74.68l1.3-1.293a4.37 4.37 0 0 0-3.065-1.183 4.53 4.53 0 0 0-4.027 2.5l1.502 1.171A2.715 2.715 0 0 1 9.629 8.44z" fill="#EA4335" />;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t8;
    $[9] = t9;
  } else {
    t10 = $[5];
    t11 = $[6];
    t12 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t13;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5 || $[13] !== t7) {
    t13 = <svg className="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 24" width="38" height="24" role={t3} aria-label={t4} aria-hidden={t5}>{t6}{t7}{t8}{t9}{t10}{t11}{t12}</svg>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  return t13;
}